module.exports = __webpack_public_path__ + "img/bck.4a733dac.png";